import axios from "axios";
import { auth } from "../core/utils/firebase";

const HttpMethods = {
  GET: 'GET',
  POST: 'POST',
  DELETE: 'DELETE',
};

const getValidToken = async () => {
  const user = auth.currentUser;
  if (!user) {
    return "";
  }
  try {
    return await user.getIdToken();
  } catch (error) {
    console.error("Error getting ID token", error);
    throw error;
  }
};

axios.interceptors.request.use(async (config) => {
  const token = await getValidToken();
  if (!token) {
    return Promise.reject(new Error("No hay sesión de Firebase"));
  }
  config.headers.Authorization = `Bearer ${token}`;
  return config;
}, (error) => {
  return Promise.reject(error);
});

const getAxiosClient = () => axios;

const HttpService = {
  HttpMethods,
  getAxiosClient,
  getValidToken,
};

export default HttpService;
